import { GetServerSidePropsContext } from 'next'
import { User } from '../../types'
import { printError } from '../log'
import { createGuest } from '../user'
import {
  basePath,
  callAPI,
  callAPIRaw,
  callAPIWithNoContent,
  callAuthAPI,
} from './common'

export const getUser = (): Promise<User> => {
  return callAPI<User>(`${basePath}/users/me`, {
    method: 'GET',
    credentials: 'include',
  })
    .then((payload) => {
      return payload
    })
    .catch((err) => {
      printError(err)
      return createGuest()
    })
}

export const getUserWithAuth = (
  ctx: GetServerSidePropsContext
): Promise<User> => {
  return callAuthAPI<User>(ctx, `${basePath}/users/me`)
    .then((payload) => {
      return payload
    })
    .catch((err) => {
      printError(err)
      return createGuest()
    })
}

export type LoginPayload = {
  email: string
  password: string
  keep_login: boolean
}

export type CheckPasswordChangeRequiredPayload = {
  email: string
  password: string
}

export const checkPasswordChangeRequired = async (
  payload: CheckPasswordChangeRequiredPayload
): Promise<Response> => {
  const body = JSON.stringify({
    user: payload,
  })
  const url = `${basePath}/users/check_password_change_required`
  return callAPIRaw(url, {
    method: 'POST',
    body: body,
  })
}

export const login = (payload: LoginPayload) => {
  const body = JSON.stringify({
    user: payload,
  })
  return callAPIWithNoContent(`${basePath}/users/login`, {
    method: 'POST',
    body,
  })
}

export const loginWithJwt = async (accessToken: string) => {
  const url = `${basePath}/v2/users/npid_login`
  const { status, headers } = await callAPIRaw(url, {
    method: 'POST',
    headers: { 'X-NPID-ACCESS-TOKEN': accessToken, 'Content-length': '0' },
  })
  return { status, headers }
}

export const loginWithUbSso = async (accessToken: string) => {
  const url = `${basePath}/v2/users/ub_sso_login`
  const { status, headers } = await callAPIRaw(url, {
    method: 'POST',
    headers: {
      'X-UB-SSO-ACCESS-TOKEN': accessToken,
      'Content-length': '0',
    },
  })
  return { status, headers }
}

export const passwordUpdateAndLogin = async (
  email: string,
  oldPassword: string,
  newPassword: string,
  keepLogin: boolean
) => {
  const url = `${basePath}/users/password_update_and_login`
  const response = await callAPIRaw(url, {
    method: 'POST',
    body: JSON.stringify({
      user: { email, oldPassword, newPassword, keepLogin },
    }),
  })
  return response
}

export const npidLogout = async () =>
  await callAPIRaw(`${basePath}/auth/logout`)
export const ssoLogout = async () =>
  await callAPIRaw(`${basePath}/auth/sso/logout`)
